export class LabModel {
    LabId: number;
    Name: string;
    LandlineNo: string;
    MobileNo: string;
    AftrOfficeHrsContactNo: string;
    Fax: string;
    Email: string;
    Website: string;
    CreatedBy: number;
    CountryId: number;
    Address1:string;
    Address2:string;    
    City: string;
    State:string;
    Zip:string;
    CountryName: string;
    ContactName: string;
    ContactNo: string;
    PageNo: number;
    PageSize: number;
}
